import { Button } from "@mui/material";
import { DialogModal } from "@zfp-akademie-a-s/zfp-design";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly isOpen: boolean;
  readonly isPending?: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
};

export const ProposedSolutionDeleteDialog = ({ isOpen, isPending, onClose, onConfirm }: Props) => {
  const { t } = useResource();

  return (
    <DialogModal
      open={isOpen}
      onClose={onClose}
      closeLabel={t(Resources.Common.Close)}
      title={t(Resources.AnalysisDetail.GoalsFulfillment.DeleteProposedSolutionTitle)}
      subtitle={t(Resources.AnalysisDetail.GoalsFulfillment.DeleteProposedSolutionText)}
      primaryAction={
        <Button variant="contained" disabled={isPending} onClick={onConfirm}>
          {t(Resources.Common.Yes)}
        </Button>
      }
    />
  );
};
